import { render, staticRenderFns } from "./viewmarksheet.vue?vue&type=template&id=aed4a320&"
import script from "./viewmarksheet.vue?vue&type=script&lang=js&"
export * from "./viewmarksheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports